import qs from 'qs';

export const isNewSearch = props => {
  const queryParams = __CLIENT__
    ? qs.parse(window.location.search, { ignoreQueryPrefix: true })
    : { newSearch: 'false' };
  return (
    queryParams.newSearch === 'true' ||
    (props.newSearchEnabled &&
      (props.abTestGroups.webSearchOptimization1 === 'I' ||
        props.abTestGroups.webSearchOptimization1 === 'G'))
  );
};
